export const jsonContentTypeHeader = {
  'Content-Type': 'application/json'
} as const

export const GLOBAL_CONTENTFUL_DELIVERY_SECRET =
  'globalContentfulDeliverySecret'
export const GLOBAL_CONTENTFUL_PREVIEW_SECRET = 'globalContentfulPreviewSecret'
